import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { FlexContainer, Paragraph, Button, AlertNegative, CheckMark } from 'heliocor-ui'

const AuthenticationStatus = ({ buttonHelper, positiveVerification, infoMessage }) => {
    const { t } = useTranslation()
    
    return (
        <FlexContainer column alignItems='center' justifyContent='center' padding='5rem' height='90%' textAlign='center' width='100%'>
            {positiveVerification ? <CheckMark sizePx='50px' /> : <AlertNegative size='50px' />}
            <Paragraph value={positiveVerification ? t('warning.authSuccess') : t(infoMessage)} />
            {buttonHelper &&
                <Fragment>
                    {buttonHelper.textInfo && <Paragraph value={t(buttonHelper.textInfo)} />}
                    <Button type='warning' value={t(buttonHelper.buttonValue)} onClick={buttonHelper.action} />
                </Fragment>
            }
        </FlexContainer>
    )
}

export { AuthenticationStatus }
